import React from 'react';
import { FadeIn } from './FadeIn';
import { ClockIcon } from 'lucide-react';
export function Mechanism() {
  return <section className="py-10 sm:py-14 relative overflow-hidden" data-id="element-248">
      <div className="absolute inset-0 bg-gold/5 skew-y-3 transform origin-top-left -z-10" data-id="element-249" />

      <div className="mx-auto max-w-4xl px-6 lg:px-8 text-center" data-id="element-250">
        <FadeIn data-id="element-251">
          <div className="inline-flex items-center justify-center p-3 bg-gold/10 rounded-2xl mb-4 ring-1 ring-gold/20" data-id="element-252">
            <ClockIcon className="h-8 w-8 text-gold" data-id="element-253" />
          </div>
          <h2 className="text-3xl sm:text-5xl font-bold mb-6 text-glow" data-id="element-254">
            Protocolo de Agotamiento Circadiano Inverso
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg text-slate-300 font-sans leading-relaxed text-left sm:text-center" data-id="element-255">
          <FadeIn delay={0.1} data-id="element-256">
            <p data-id="element-257">
              Este sistema no se basa en la disciplina, sino en la{' '}
              <strong className="text-gold font-semibold" data-id="element-258">
                etología aplicada
              </strong>
              .
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-259">
            <p data-id="element-260">
              Aplicamos un ciclo de picos de actividad estratégica que resetea
              el reloj biológico de tu gato. Alineamos su necesidad de "cazar y
              comer" con tu necesidad de dormir.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-261">
            <p className="text-xl text-slate-100 font-medium mt-8 border-l-4 border-gold pl-6 sm:border-l-0 sm:pl-0" data-id="element-262">
              Forzando a su cuerpo a entrar en fase de sueño profundo
              exactamente cuando vos apagás la luz.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}